import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toReal'
})
export class ToRealPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
